import { render, staticRenderFns } from "./haed.vue?vue&type=template&id=1053cba0&scoped=true"
import script from "./haed.vue?vue&type=script&lang=ts"
export * from "./haed.vue?vue&type=script&lang=ts"
import style0 from "./haed.vue?vue&type=style&index=0&id=1053cba0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1053cba0",
  null
  
)

export default component.exports